// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/win-chat-analytics/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/win-chat-analytics/")({
  component: PageComponent,

})

function PageComponent() {
  return <Page />
}
